import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';

export type Interface = ApiInterface<{
  response: { success: true };
  pathParams: { noteClientId: string };
  body: EmptyObject;
  claims: { tenantId: string };
  queryParams: { clientId: string };
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-delete-note-client',
  method: 'DELETE',
  basePath: 'notes-client',
  path: '/{noteClientId}',
  tablePermission: 'readWrite',
  scope: 'RECEPTIONIST',
};
